import { render, staticRenderFns } from "./EPromoterNoData.vue?vue&type=template&id=2ee8fe6a&scoped=true&"
import script from "./EPromoterNoData.vue?vue&type=script&lang=js&"
export * from "./EPromoterNoData.vue?vue&type=script&lang=js&"
import style0 from "./EPromoterNoData.vue?vue&type=style&index=0&id=2ee8fe6a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ee8fe6a",
  null
  
)

export default component.exports